import React from 'react'
import { Link } from 'react-router-dom'

function PostsWpListTemplate({post}) {

    const DEFAULT_IMAGE_URL = "https://progitek.no/privat/bp/wp-content/uploads/2020/08/pexels-tembela-bohle-1884576.jpg"

    return (
        <div className="col-md-6 col-lg-4 my-3">
            <div className="card">
                <img src={post.acf.featured_image_post || DEFAULT_IMAGE_URL} alt="" />
                <div className="card-body">
                    <h5 className="font-weight-bold"><Link to={`/innlegg-wp/${post.id}`}>{post.title.rendered}</Link></h5>
                </div>
            </div>
        </div>
    )
}
export default PostsWpListTemplate